import { useState, useEffect, useMemo } from "react";
import {saveAs} from "file-saver";
import { Link, useHistory } from "react-router-dom";
//---------------------------------------------
import UserInfo from "src/components/common/userInfo";
import Modal from "src/components/common/modal";
import CurrentMaterialCost from "src/components/common/currentMaterialCost";
import { useMyStore } from "src/components/main/mainStore";
import {
    Select, 
    getDatefromWeekNum0, 
    mimeTypeMap, 
    myAxios, 
    MyFormData, 
    numberReducer, 
    handleFilesInput,
    isDevMode, 
    MyDate, 
} from "src/components/common/functions";
//---------------------------------------------
export default function BillingForm({
    keyword, 
    closeIt, 
    updateDateTime, 
    curWeekStart, 
    curWeekEnd, 
    users, 
    projects, 

    billingNumber, 
    amount, 
    startDate, 
    endDate, 
    projectHashKey, 
    notes, 
    pdfId, 
    approval
}){
    const projectsWithLabels = useMemo(() => projects.map(project => ({...project, value: project.projectHashKey, label:project.projectName})), [projects]);
    //--------------------------------------------------------------------------------------------
    // if(isDevMode) console.log("all");
    //--------------------------------------------------------------------------------------------
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const setBillings = useMyStore(state => state.setBillings);
    const allWorkLogs = useMyStore(state => state.billingWorkLogs);
    const setWorkLogs = useMyStore(state => state.setBillingWorkLogs);
    //---------------------------------------------
    const history = useHistory();
    const path = history.location.pathname;
    const path1 = decodeURIComponent(path.split("/")[1] ?? "");
    //---------------------------------------------
    const defaultApprover = ![undefined, ""].includes(approval)?users.find(thisUser => 
        thisUser.email === JSON.parse(approval)[0].candidateEmail[0]
    ) ?? "" : "";
    //---------------------------------------------
    const [curApprover, setApprover] = useState(defaultApprover);
    const [curProjectHashKey, setProjectHashKey] = useState(projectHashKey ?? "");
    const [curBillingNumber, setBillingNumber] = useState(billingNumber ?? "");
    const [curStartDate, setStartDate] = useState(startDate ?? "");
    const [curEndDate, setEndDate] = useState(endDate ?? "");
    const [invalidText, setInvalidText] = useState();
    //---------------------------------------------
    const workLogs = allWorkLogs[curProjectHashKey] ?? [];
    const dateMin = workLogs.length ? workLogs[0].startTime.substring(0, 10) : "";
    const dateMax = workLogs.length ? workLogs[workLogs.length - 1].startTime.substring(0, 10) : "";
    //---------------------------------------------
    const handleSubmit = async event => {
        event.preventDefault();
        const formData = new MyFormData(event.currentTarget);
        if(!formData.get("approverEmail")){
            window.alert("Please select an approver.");
            return;
        }
        if(!formData.get("projectHashKey")){
            window.alert("Please select a project.");
            return;
        }
        //-------------------------------------------------
        setShowLoader(true);
        const poRes = await myAxios("billings/validate.php", formData);
        setShowLoader(false);
        if(!poRes) return;
        //-------------------------------------------------
        const ranges = billingNumber?
        poRes.data.filter(billing => billing.billingNumber !== billingNumber)
        :
        poRes.data;
        for(let range of ranges){
            const {startDate, endDate} = range;
            const before = formData.get("endDate") < startDate;
            const after = formData.get("startDate") > endDate;
            const valid = before || after;
            if(!valid){
                setInvalidText(range);
                window.alert("Time conflict. Please check.");
                return;
            }else{
                setInvalidText();
            }
        }
        const curProject = projects.find(project => project.projectHashKey === curProjectHashKey);
        curProject ?? formData.append("projectName", curProject.projectName);
        formData.append("start", getDatefromWeekNum0(curWeekStart, 0).toLocaleDateString("fr-CA", {timeZone: "America/Los_Angeles"}));
        formData.append("end", getDatefromWeekNum0(curWeekEnd, 7).toLocaleDateString("fr-CA", {timeZone: "America/Los_Angeles"}));
        //-------------------------------------------------
        setShowLoader(true);
        const res = await myAxios(formData.get("action") === "Add"?"billings/createBilling.php":"billings/updateBilling.php", formData);
        setShowLoader(false);
        if(!res) return;
        //-------------------------------------------------
        setBillings(curWeekStart, curWeekEnd, res.data);
        history.replace(`/${path1}`);
    }
    useEffect(() => {
        if(!curProjectHashKey || (allWorkLogs[curProjectHashKey] && updateDateTime["Work Logs"] === allWorkLogs.updatedAt)) return;
        let isMounted = true;
        const controller = new AbortController();
        const getData = async() => {
            if(isDevMode) console.log("useEffect form");
            const formData = new MyFormData(); 
            formData.append("projectHashKey", curProjectHashKey);
            setShowLoader(true);
            const resWorkLogs = await myAxios("billings/readBillingAllWorkLogs.php", formData, undefined, controller.signal);
            if(!isMounted) return;
            setShowLoader(false);
            if(!resWorkLogs) return;
            //-------------------------------------------------
            setWorkLogs(
                curProjectHashKey, 
                resWorkLogs.data, 
                updateDateTime["Work Logs"]
            );
        }
        getData();
        return () => {
            isMounted = false;
            controller.abort();
            setShowLoader(false);
        }
    }, [curProjectHashKey, projectHashKey, setShowLoader, setWorkLogs, allWorkLogs, updateDateTime])
    return(
        <Modal
            closeIt = {closeIt}
            title = {keyword}
            width = {"1200px"}
            handleFormSubmit = {handleSubmit}
            actionKey = {keyword}
        >
            <div>
                <input
                    className = "nodisplay" readOnly
                    name = "action" value = {keyword}
                />
                <input
                    className = "nodisplay" readOnly
                    name = "pdfId" value = {pdfId}
                />
                <input
                    className = "nodisplay" readOnly
                    name = "preBillingNumber" value = {billingNumber}
                />
                <div className = "d-flex align-items-center my-2">
                    <label htmlFor = "billingNumber" className = "font-weight-bold required-field mb-0">Billing Number:</label>
                    <input
                        id = "billingNumber"
                        required
                        className = "form-control flex-grow-1 ml-2"
                        name = "billingNumber"
                        value = {curBillingNumber}
                        onChange = {e => {setBillingNumber(
                            e.currentTarget.value.replace(/ /g,"").replace(/\//g,"").replace(/"/g,"").replace(/'/g,"")
                        )}}
                    />
                </div>
                <div className = "d-flex align-items-center my-2">
                    <label htmlFor = "projectName" className = "font-weight-bold required-field mb-0">Project Name:</label>
                    <div className = "flex-grow-1 ml-2">
                        <Select
                            inputId = "projectName"
                            name = "projectHashKey"
                            value = {projectsWithLabels.find(project => project.projectHashKey === curProjectHashKey)}
                            onChange = {e => {
                                setStartDate("");
                                setEndDate("");
                                setInvalidText();
                                setProjectHashKey(e?.value);
                            }}
                            options = {projectsWithLabels}
                        />
                        <input
                            className = "nodisplay" readOnly
                            name = "projectHashKey" value = {curProjectHashKey}
                        />
                    </div>
                </div>
                {curProjectHashKey?<>
                <CurrentMaterialCost
                    className = ""
                    uid = "inner"
                    updateDateTime = {updateDateTime}
                    projectHashKey = {curProjectHashKey ?? ""}
                    projectName = {projects.find(project => project.projectHashKey === projectHashKey)?.projectName ?? ""}
                />
                <div>
                    <div className = "d-flex align-items-center my-2">
                        <label htmlFor = "startDate" className = "font-weight-bold required-field mb-0">Start Date:</label>
                        <input
                            id = "startDate"
                            type = "date"
                            min = {dateMin || "1900-01-01"}
                            max = {dateMax || "2999-12-31"} 
                            required
                            className = "form-control flex-grow-1 ml-2"
                            name = "startDate"
                            value = {curStartDate}
                            onChange = {e => {
                                setStartDate(e.currentTarget.value);
                                setInvalidText();
                            }}
                        />
                        <label htmlFor = "endDate" className = "font-weight-bold required-field mb-0 ml-3">End Date:</label>
                        <input
                            id = "endDate"
                            type = "date"
                            min = {(curStartDate > dateMin?curStartDate : dateMin) || "1900-01-01"}
                            max = {dateMax || "2999-12-31"}
                            required
                            className = "form-control flex-grow-1 ml-2"
                            name = "endDate"
                            value = {curEndDate}
                            onChange = {e => {
                                setEndDate(e.currentTarget.value);
                                setInvalidText();
                            }}
                        />
                    </div>
                    {invalidText?
                    <span className = "mx-3 text-danger font-weight-bold">
                        <span className = "mr-1">
                            conflict with
                        </span>
                        <Link to = {`/${path1}/${invalidText.billingNumber}`}>
                            from {invalidText.startDate} to {invalidText.endDate}
                        </Link>
                    </span>
                    :<></>}
                    <button type = "button" className = "ml-2 btn btn-success"onClick = {async () => {
                        if(!window.confirm("Are you sure to download all Job Tags?")) return;
                        const selectedWorkLogs = workLogs.filter(workLog => workLog.startTime.substring(0, 10) >= curStartDate && workLog.startTime.substring(0, 10) <= curEndDate);
                        if(!selectedWorkLogs.length){
                            window.alert("No Job Tags Selected. Select ob Tags By Entering `Start Date` and `End Date` Above.");
                            return;
                        }
                        if(selectedWorkLogs.filter(workLog => workLog.workLogStatus === "Submitted").length){
                            if(!window.confirm("You have unapproved Job Tags. Still proceed?")) return;
                        }
                        window.alert("WARNING: You will still need to verify that there are no remaining Job Tags assigned to this BTL in order to proceed with the billing process.");
                        const formData = new MyFormData();
                        for(const workLog of selectedWorkLogs){
                            formData.append("fileId[]", workLog.jobTag);
                            const duration = workLog.startTime.substring(0, 10) === workLog.endTime.substring(0, 10)?workLog.startTime.substring(0, 10):`from ${workLog.startTime.substring(0, 10)} to ${workLog.endTime.substring(0, 10)}`;
                            formData.append("fileName[]", `${workLog.laborName} ${duration}.pdf`);
                        }
                        //-------------------------------------------------------------------
                        setShowLoader(true);
                        const res = await myAxios("common/getFile.php", formData, "blob");
                        setShowLoader(false);
                        if(!res) return;
                        //-------------------------------------------------------------------
                        const now = new MyDate();
                        if(selectedWorkLogs.length === 1){
                            saveAs(new Blob([res.data], {type: mimeTypeMap.pdf}), `${curBillingNumber} Downloaded at ${now.s()} ${now.ss()}.pdf`);
                        }else{
                            saveAs(new Blob([res.data], {type: mimeTypeMap.zip}), `${curBillingNumber} Downloaded at ${now.s()} ${now.ss()}.zip`);
                        }
                    }}>
                        Download Selection
                    </button>
                </div>
                <div className = "table-responsive" style = {{minWidth: "800px",maxWidth: "90%", margin: "20px auto"}}>
                    <table className = "table">
                        <thead>
                            <tr>
                                <th>Duration</th>
                                <th>Technician</th>
                                <th>Job Tag</th>
                                <th>Status</th>
                                <th>Total Hours</th>
                            </tr>
                        </thead>
                        <tbody>
                            {workLogs.map((renderedWorkLog, wLIndex) => 
                            <tr key = {wLIndex} style = {{background: renderedWorkLog.startTime.substring(0, 10) >= curStartDate && renderedWorkLog.startTime.substring(0, 10) <= curEndDate?"#90EE90":""}}>
                                <td>
                                    <strong>
                                        <span style = {{fontSize: 20}}>
                                            {renderedWorkLog.startTime.substring(0, 10)}
                                        </span>
                                        {
                                            renderedWorkLog.startTime.substring(11, 16) === "00:00" && renderedWorkLog.endTime.substring(11, 16) === "00:00"?
                                            ``
                                            :
                                            ` ${renderedWorkLog.startTime.substring(11, 16)}`
                                        }
                                        {
                                            renderedWorkLog.startTime.substring(0, 10) === renderedWorkLog.endTime.substring(0, 10) && renderedWorkLog.startTime.substring(11, 16) === "00:00" && renderedWorkLog.endTime.substring(11, 16) === "00:00"?
                                            ``
                                            :
                                            ` ~ `
                                        }
                                        {
                                            renderedWorkLog.startTime.substring(0, 10) === renderedWorkLog.endTime.substring(0, 10)?
                                                renderedWorkLog.startTime.substring(11, 16) === "00:00" && renderedWorkLog.endTime.substring(11, 16) === "00:00"?
                                                ``
                                                :
                                                renderedWorkLog.endTime.substring(11, 16)
                                            :
                                                renderedWorkLog.startTime.substring(11, 16) === "00:00" && renderedWorkLog.endTime.substring(11, 16) === "00:00"?
                                                <span style = {{fontSize: 20}}>{renderedWorkLog.endTime.substring(0, 10)}</span>
                                                :
                                                <>
                                                    <span style = {{fontSize: 20}}>{renderedWorkLog.endTime.substring(0, 10)} </span>
                                                    {renderedWorkLog.endTime.substring(11, 16)}
                                                </>
                                        }
                                    </strong>
                                </td>
                                <td>
                                    <UserInfo 
                                        name = {renderedWorkLog.laborName}
                                        email = {renderedWorkLog.labor}
                                    />
                                </td>
                                <td>
                                    <button type = "button" className = "btn btn-primary" onClick = {async () => {
                                        const formData = new MyFormData();
                                        formData.append("fileId[]", renderedWorkLog.jobTag);
                                        const duration = renderedWorkLog.startTime.substring(0, 10) === renderedWorkLog.endTime.substring(0, 10)?renderedWorkLog.startTime.substring(0, 10):`from ${renderedWorkLog.startTime.substring(0, 10)} to ${renderedWorkLog.endTime.substring(0, 10)}`;
                                        formData.append("fileName[]", `${renderedWorkLog.laborName} ${duration}.pdf`);
                                        //-------------------------------------------------
                                        setShowLoader(true);
                                        const res = await myAxios("common/getFile.php", formData, "blob");
                                        setShowLoader(false);
                                        if(!res) return;
                                        //-------------------------------------------------
                                        saveAs(new Blob([res.data]), `${renderedWorkLog.laborName} ${duration}.pdf`);
                                    }}>
                                        Download
                                    </button>
                                </td>
                                <td className = {renderedWorkLog.workLogStatus === "Submitted"?"text-danger":""}>
                                    {renderedWorkLog.workLogStatus}
                                </td>
                                <td>
                                    <li>Travel: {((
                                        (new Date(renderedWorkLog.workStartTime.replace(/-/, "/")) - new Date(renderedWorkLog.travelStartTime.replace(/-/, "/")))
                                        + 
                                        (new Date(renderedWorkLog.travelEndTime.replace(/-/, "/")) - new Date(renderedWorkLog.workEndTime.replace(/-/, "/")))
                                        ) / 3600000).toFixed(2)}</li>
                                    <li>Work: {((new Date(renderedWorkLog.workEndTime.replace(/-/, "/")) - new Date(renderedWorkLog.workStartTime.replace(/-/, "/"))) / 3600000).toFixed(2)}</li>
                                    <li>Total: {((new Date(renderedWorkLog.travelEndTime.replace(/-/, "/")) - new Date(renderedWorkLog.travelStartTime.replace(/-/, "/"))) / 3600000).toFixed(2)}</li>
                                </td>
                            </tr>)}
                            <tr>
                                <td style = {{textAlign: "right"}}><strong>Selected Total:</strong></td>
                                <td>
                                    <li>Travel: {(workLogs.filter(workLog => workLog.startTime.substring(0, 10) >= curStartDate && workLog.startTime.substring(0, 10) <= curEndDate).map(workLog => (
                                        (new Date(workLog.workStartTime.replace(/-/, "/")) - new Date(workLog.travelStartTime.replace(/-/, "/")))
                                        + 
                                        (new Date(workLog.travelEndTime.replace(/-/, "/")) - new Date(workLog.workEndTime.replace(/-/, "/")))
                                        ) / 3600000).reduce(numberReducer, 0)).toFixed(2)}</li>
                                    <li>Work: {(workLogs.filter(workLog => workLog.startTime.substring(0, 10) >= curStartDate && workLog.startTime.substring(0, 10) <= curEndDate).map(workLog => (new Date(workLog.workEndTime.replace(/-/, "/")) - new Date(workLog.workStartTime.replace(/-/, "/"))) / 3600000).reduce(numberReducer, 0)).toFixed(2)}</li>
                                    <li>Total: {(workLogs.filter(workLog => workLog.startTime.substring(0, 10) >= curStartDate && workLog.startTime.substring(0, 10) <= curEndDate).map(workLog => (new Date(workLog.travelEndTime.replace(/-/, "/")) - new Date(workLog.travelStartTime.replace(/-/, "/"))) / 3600000).reduce(numberReducer, 0)).toFixed(2)}</li>
                                </td>
                                <td style = {{textAlign: "right"}}><strong>Total:</strong></td>
                                <td>
                                    <li>Travel: {(workLogs.map(workLog => (
                                        (new Date(workLog.workStartTime.replace(/-/, "/")) - new Date(workLog.travelStartTime.replace(/-/, "/")))
                                        + 
                                        (new Date(workLog.travelEndTime.replace(/-/, "/")) - new Date(workLog.workEndTime.replace(/-/, "/")))
                                        ) / 3600000 ).reduce(numberReducer, 0)).toFixed(2)}</li>
                                    <li>Work: {(workLogs.map(workLog => (new Date(workLog.workEndTime.replace(/-/, "/")) - new Date(workLog.workStartTime.replace(/-/, "/"))) / 3600000).reduce(numberReducer, 0)).toFixed(2)}</li>
                                    <li>Total: {(workLogs.map(workLog => (new Date(workLog.travelEndTime.replace(/-/, "/")) - new Date(workLog.travelStartTime.replace(/-/, "/"))) / 3600000).reduce(numberReducer, 0)).toFixed(2)}</li>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className = "d-flex align-items-center my-2">
                    <label htmlFor = "amount" className = "font-weight-bold mr-3 required-field mb-0">Amount ($):</label>
                    <input
                        id = "amount"
                        type = "number"
                        required
                        className = "form-control flex-grow-1"
                        step = {"0.01"}
                        name = "amount"
                        defaultValue = {amount}
                    />
                    <input
                        className = "nodisplay" readOnly
                        name = "approverEmail" value = {curApprover?.value ?? ""}
                    />
                    <input
                        className = "nodisplay" readOnly
                        name = "approver" value = {curApprover?.label ?? ""}
                    />
                </div>
                <div className = "d-flex align-items-center my-2">
                    <label htmlFor = "approverName" className = "font-weight-bold required-field mb-0">Approver:</label>
                    <div className = "flex-grow-1 ml-2">
                        <Select
                            inputId = "approverName"
                            value = {curApprover}
                            onChange = {e => {setApprover(e)}}
                            options = {
                                users
                                .filter(thisUser => thisUser.purchases === "approver")
                                .map(thisUser => ({label: thisUser.userName, value: thisUser.email}))
                            }
                        />
                        <input
                            className = "nodisplay" readOnly
                            name = "approverEmail" value = {curApprover?.email ?? ""}
                        />
                        <input
                            className = "nodisplay" readOnly
                            name = "approver" value = {curApprover?.label ?? ""}
                        />
                    </div>
                </div>
                {keyword === "Add"?
                <div className = "d-flex align-items-center my-2">
                    <label htmlFor = "pdf" className = "font-weight-bold text-nowrap mb-0">Add file below:</label>
                    <div className = "custom-file ml-2">
                        <input
                            id = "pdf"
                            type = "file"
                            required
                            accept = {mimeTypeMap.pdf}
                            className = "custom-file-input"
                            name = "pdf"
                            onChange = {handleFilesInput}
                        />
                        <label htmlFor = "notes" className = "custom-file-label">Choose file</label>
                    </div>
                </div>:<></>}
                <div className = "d-flex align-items-center my-2">
                    <label htmlFor = "notes" className = "font-weight-bold mb-0">
                        Notes:
                    </label>
                    <textarea
                        id = "notes"
                        name = "notes"
                        defaultValue = {notes ?? ""}
                        className = "form-control flex-grow-1 ml-2"
                    />
                </div>
                </>:<></>}
            </div>
        </Modal>
    )
}